import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';

export const getEmploymentStatus = createAsyncThunk('employmentStatusSlice/getEmploymentStatus', async () => {
    try {
        let response = await axios.get('/employment-status', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEmploymentStatusOption = createAsyncThunk('employmentStatusSlice/getEmploymentStatusOption', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/employment-status/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createEmploymentStatus = createAsyncThunk('employmentStatusSlice/createEmploymentStatus', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/employment-status', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Employment Status created successfully.');
        dispatch(getEmploymentStatus());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateEmploymentStatus = createAsyncThunk('employmentStatusSlice/updateEmploymentStatus', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/employment-status/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Employment Status updated successfully.');
        dispatch(getEmploymentStatus());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteEmploymentStatus = createAsyncThunk('employmentStatusSlice/deleteEmploymentStatus', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/employment-status/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Employment Status deleted successfully');
        dispatch(getEmploymentStatus());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateEmploymentActiveStatus = createAsyncThunk(
    'employmentStatusSlice/updateEmploymentActiveStatus',
    async (id, { dispatch }) => {
        try {
            showLoader(true);

            let response = await axios.put('/employment-status/status/' + id, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            toast.success(response?.data?.message || 'Status updated successfully.');
            dispatch(getEmploymentStatus());
            showLoader(false);
            return Promise.resolve(response.data);
        } catch (err) {
            showLoader(false);
            toast.err(err?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(err);
        }
    }
);

export const employmentStatusSlice = createSlice({
    name: 'employmentStatusSlice',
    initialState: {
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getEmploymentStatus.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getEmploymentStatusOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
    }
});

export default employmentStatusSlice.reducer;
